<template>

  <div class="page-wrapper">
    <div style="width: 100%; height: 50px;line-height: 50px; font-size: 25px; font-weight: bold; ">
      <span style="font-size: 20px; cursor: pointer;" @click="moveTo(prev)">{{prev}}</span>
      <span style="margin-right: 30px; cursor: pointer;" @click="moveTo(prev)"><i class="fas fa-chevron-left"></i></span>
      {{currentMonth}}
      <span style="margin-left: 30px; cursor: pointer;" @click="moveTo(next)"><i class="fas fa-chevron-right"></i></span>
      <span style="font-size: 20px; cursor: pointer;" @click="moveTo(next)">{{next}}</span>
    </div>
    <div style="width: 100%; height: calc(100% - 50px); display: flex;position: relative;">
      <div class="month-view">
        <div class="weekdays" style="width: 100%; height: 50px;">
          <div>Mo</div>
          <div>Tu</div>
          <div>We</div>
          <div>Th</div>
          <div>Fr</div>
          <div>Sa</div>
          <div>Su</div>
        </div>
        <div class="days" style="width: 100%; height: calc(100% - 50px);">
          <div v-for="day in days" style="position: relative;" v-on:click="selectedDay = day">
            <div style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;">
              <div style="width: 100%; text-align: center; height: 25px; line-height: 25px; cursor: pointer;">
                <span v-bind:class="{'today-highlight': day.day === today}">{{day.date}}</span>
              </div>
              <div class="calendar-task"
                   v-for="item in day.items"
                  v-bind:class="{'calendar-task-visit': day.day === item.visitDate, 'calendar-task-packing': day.day === item.packingDate}">
                {{getTitle(item, day.day)}}
              </div>
            </div>

          </div>
        </div>
      </div>
      <div style="position: fixed; cursor: pointer; bottom: 20px; right: 20px; padding: 10px; background-color: #C4EACF; color:black; font-weight: bold; border-radius: 10px; box-shadow: 3px 3px 5px gray;"
           v-if="editItem === false" v-on:click="createNewItem">
        추가하기
      </div>
      <div style="position: fixed; cursor: pointer; bottom: 20px; right: 120px; padding: 10px; background-color: #FFB89D; color:black; font-weight: bold; border-radius: 10px; box-shadow: 3px 3px 5px gray;"
           v-if="waitingItems === false" v-on:click="getWaitingItems">
        대기
      </div>
      <transition name="slide">
      <div class="day-view" v-if="selectedDay !== false">
        <div style="width:100%; height: 50px; line-height: 50px; font-size: 25px; font-weight: bold; border-bottom: 1px solid #DDDDDD; text-align: left; padding-left: 20px;">
          {{selectedDay.day}} / <span>{{selectedDay.items.length}}건</span><span style="float:right; margin-right:20px;" @click="selectedDay = false">닫기</span>
        </div>
        <div style="width: 100%; height: calc(100% - 50px); overflow-y: auto;">
          <div class="calendar-task-card" v-for="item in selectedDay.items" v-on:click="openItem(item.id)">
            <div style="line-height: 30px; font-weight: bold; font-size: 20px;"><strong>{{getTitle(item, selectedDay.day)}}</strong></div>
            <div>방문일: {{item.visitDate}} {{item.visitHour}}시</div>
            <div>이사일: {{item.packingDate}}</div>


            <div>고객: {{item.requester}}</div>
            <div>전화: {{item.phoneNumber}}</div>
            <div>위치: {{item.addressFrom}}</div>

            <div>부피: {{item.cubes}}큐빅</div>
            <div v-if="item.vehicles !== null && item.vehicles.length > 0">
              차량: {{item.vehicles.join(',')}}
            </div>
            <div v-if="item.contractors !== null && item.contractors.length > 0">
              외주인력: {{item.contractors.join(',')}}
            </div>
          </div>
        </div>
      </div>
      </transition>
    </div>
    <transition name="vertical">
    <div style="position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);" v-if="waitingItems !== false" @click="waitingItems = false">
      <div style="position: absolute; top:50%; left: 50%; width: calc(100% - 20px); max-width: 1140px; height: 90%; transform: translate(-50%, -50%); background-color: white; overflow-y: auto;" v-on:click.stop="dummy">
        <table class="table text-left">
          <tr class="sticky-header">
            <th>Ref</th>
            <th>상태</th>

            <th>방문 요청 일시</th>
            <th>신청자</th>
            <th class="hide-mobile">전화번호</th>
            <th class="hide-mobile">이메일</th>
            <th class="hide-mobile">이사종류</th>
            <th class="hide-mobile">From</th>
            <th class="hide-mobile">To</th>
            <th class="hide-mobile">접수일</th>
          </tr>
          <tbody>
          <tr v-for="item in waitingItems">
            <td><span v-on:click="openItem(item.id)">{{item.reference}}</span></td>
            <td>{{getStateString(item.state)}}</td>

            <td>{{item.visitDate}} {{item.visitHour}}시</td>
            <td>
              <span v-if="item.companyName !== null && item.companyName.length > 0">{{item.companyName}}<br></span>
              {{item.requester}}
            </td>
            <td class="hide-mobile">{{item.phoneNumber}}</td>
            <td class="hide-mobile">{{item.email}}</td>
            <td class="hide-mobile">{{getMoveTypeString(item.requestType)}}</td>
            <td class="hide-mobile">{{item.addressFrom}}</td>
            <td class="hide-mobile">{{item.countryTo}}<br>{{item.addressTo}}</td>
            <td>{{getDateString(item.createdTimestamp)}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    </transition>
    <transition name="vertical">
    <div style="position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);" v-if="editItem != false">
      <div style="position: absolute; top:50%; left: 50%; width: calc(100% - 20px); max-width: 1140px; height: 90%; transform: translate(-50%, -50%); background-color: white;" v-on:click.stop="dummy">
        <request-item-view
          :item="editItem"
          :on-updated="onItemUpdated"
          :on-close="onItemClosed"
          :on-deleted="onItemDeleted"/>

      </div>
    </div>
    </transition>


  </div>
</template>

<script>
  import {getDateString, millisToDate, millisToYM, showDialog} from "../api/utils";
  import {
    createNewRequest,
    getRequest,
    getRequestsForCalendar,
    getRequestsWaiting,
    getStateList,
    moveTypeString
  } from "../api/request";
  import RequestItemView from "./RequestItemView";

    export default {
      name: "CalendarView",
      data() {
        return {
          currentMonth:'',
          days:[],
          today:'',
          selectedDay:false,
          editItem: false,
          items:[],
          prev:'',
          next:'',
          waitingItems:false,
          stateList: getStateList(),
        }
      },
      components: {
        RequestItemView,
      },
      created() {
      },
      mounted() {
        this.$data.today = getDateString(new Date().getTime());
        this.updateView();
      },
      watch:{

      },
      beforeDestroy() {
      },
      destroyed() {
      },
      methods: {
        dummy: function() {

        },
        getDateString:millisToDate,
        getMoveTypeString: moveTypeString,
        getStateString: function(state) {
          for(let i = 0 ; i < this.$data.stateList.length ; i++) {
            if(this.$data.stateList[i].value == state) {
              return this.$data.stateList[i].title;
            }
          }
          return 'Unknown('+state +')';
        },
        moveTo: function(month) {
          if(this.$data.currentMonth === month) {
            return;
          }
          this.$data.currentMonth = month;
          this.updateView();
        },
        getTitle: function(item, date) {
          let title = '';
          if(item.cubes > 0) {
            title += item.cubes;
          }
          if(item.itemType !== null && item.itemType.length > 0) {
            title += item.itemType;
          }

          if(item.vehicles !== null && item.vehicles.length > 0) {
            title += item.vehicles.join(',');
          }

          console.log(date);
          console.log(item);
          if(date === item.visitDate) {
            title += '(' + item.visitHour + '시)';
          }
          if(item.contractors !== null && item.contractors.length > 0) {
            title += item.contractors.join(',');
          }

          if(title === '') {
            title = item.requester;
          }
          return title;
        },
        updateView: function() {
          console.log("update view");
          this.$data.days = [];
          if(this.$data.currentMonth === null || this.$data.currentMonth === '') {
            let today = new Date();
            this.$data.currentMonth = millisToYM(today.getTime());
          }
          let firstDay = new Date(this.$data.currentMonth + '-01');

          let prevMon = new Date(firstDay.getFullYear(), firstDay.getMonth()-1, 1);
          let nexMon = new Date(firstDay.getFullYear(), firstDay.getMonth()+1, 1);
          this.$data.prev = millisToYM(prevMon.getTime());
          this.$data.next = millisToYM(nexMon.getTime());
          console.log("first day " + getDateString(firstDay.getTime()));
          let firstDayOfWeek = firstDay.getDay() - 1;
          if(firstDayOfWeek < 0) {
            firstDayOfWeek = 6;
          }

          console.log("first day of week " + firstDayOfWeek);
          for(let i = firstDayOfWeek ; i > 0 ; i--) {
            let day = getDateString(firstDay.getTime(), -i);

            let date = new Date(day).getDate();

            let dayItem = {
              day: day,
              date:date,
              type:'previous',
              items:[],
            };
            this.$data.days.push(dayItem);
          }

          let lastDayOfMonth = new Date(firstDay.getFullYear(), firstDay.getMonth()+1, 0).getDate();
          console.log("last day " + lastDayOfMonth);
          //
          for(let i = 1 ; i <= lastDayOfMonth ; i++) {
            let day = new Date(firstDay.getFullYear(), firstDay.getMonth(), i);
            let dayString = getDateString(day.getTime());

            let dayItem = {
              day: dayString,
              date: i,
              type:'current',
              items:[],
            }
            this.$data.days.push(dayItem);
          }


          let lastDate= new Date(firstDay.getFullYear(), firstDay.getMonth()+1, 0);
          let lastDayOfWeek = lastDate.getDay()-1;
          if(lastDayOfWeek < 0) {
            lastDayOfWeek = 6;
          }

          if(lastDayOfWeek < 6) {
            for(let i = 1 ; lastDayOfWeek+i <= 6 ; i ++) {
              let day = new Date(lastDate.getFullYear(), lastDate.getMonth()+1, i);
              let dayString = getDateString(day.getTime());

              let dayItem = {
                day: dayString,
                date: i,
                type:'next',
                items:[],
              }
              this.$data.days.push(dayItem);
            }
          }
          this.getJobList();


        },
        getJobList: function() {

          let from = this.$data.days[0].day;
          let to = this.$data.days[this.$data.days.length-1].day;
          this.$data.items = [];
          let self = this;
          getRequestsForCalendar(from, to)
          .then(function(data) {
            if(data.success === true) {
              self.sortItems(data.item);
            }
          })
          .catch(function(err) {

          })
        },
        sortItems: function(list) {
          for(let i = 0 ; i < list.length ; i++) {
            for(let j = 0 ; j < this.$data.days.length ; j++) {
              if(this.$data.days[j].day === list[i].visitDate || this.$data.days[j].day === list[i].packingDate) {
                this.$data.days[j].items.push(list[i]);
              }
            }
          }
        },
        openItem: function(id) {
          let self = this;
          getRequest(id)
            .then(function(data) {
              if(data.success == true) {
                self.$data.editItem = data.item;
                // self.sortGoods();
              }
            })
            .catch(function(err) {

            })
        },
        onItemDeleted: function(item) {
          for(let i = 0 ; i < this.$data.days.length ; i++) {
            for(let j = this.$data.days[i].items.length - 1 ; j >= 0 ; j--) {
              if(this.$data.days[i].items[j].id === item.id) {
                this.$data.days[i].items.splice(j, 1);

              }
            }
          }
          this.$data.editItem = false;
        },
        onItemUpdated: function(item) {

          for(let i = 0 ; i < this.$data.days.length ; i++) {
            let found = false;
            for(let j = this.$data.days[i].items.length - 1 ; j >= 0 ; j--) {
              if(this.$data.days[i].items[j].id === item.id) {
                if(item.visitDate === this.$data.days[i].day || item.packingDate === this.$data.days[i].day) {
                  this.$data.days[i].items.splice(j, 1, item);
                } else {
                  this.$data.days[i].items.splice(j, 1);
                }
                found = true;
              }
            }

            if(found === false) {
              if(item.visitDate === this.$data.days[i].day || item.packingDate === this.$data.days[i].day) {
                this.$data.days[i].items.push(item);
              }
            }

          }

        },
        onItemClosed: function() {
          this.$data.editItem = false;
        },
        createNewItem: function() {
          this.$data.editItem = createNewRequest();
        },
        getWaitingItems: function() {
          this.$data.waitingItems = [];
          let self = this;
          getRequestsWaiting()
          .then(function(data) {
            if(data.success === true) {
              self.$data.waitingItems = data.item;
            } else {
              showDialog("미확정 신청건이 없습니다.");
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalendarView.vue